import React from "react"
import { useNavigate } from "react-router-dom"

const commonjs = require("./../js/common.js")
class ReComponent extends React.Component {
	constructor(props) {
		super(props)
		this.cleanupResource = this.cleanupResource.bind(this) // 리소스 초기화
	}

	componentDidMount() {
		this.cleanupResource() // cleanupResource 호출
	}

	componentWillUnmount() {
		this.cleanupResource() // cleanupResource 호출
	}

	cleanupResource() {}

	componentDidUpdate(prevProps, prevState, snapshot) {
		this.cleanupResource()
	}

	shouldComponentUpdate(nextProps, nextState, nextContext) {
		this.cleanupResource()
		return true
	}

	render() {
		this.createIframeHtml =
			`<iframe
			src="` +
			commonjs.IframeUrl() +
			`"
			id="swaggerIframe"
			title="swaggerIframe"
			width="100%"
			height="1000"
			display="block" 
			allowFullScreen = true
			seamless= false
			overflow = "hidden"
			lang="ko"
	  	/>`
		return <div id="targetFrame" dangerouslySetInnerHTML={{ __html: this.createIframeHtml }} />
	}
}

const Content = () => {
	const navigate = useNavigate() // 유지필수
	return <ReComponent />
}

export default Content
